// @flow
import * as React from 'react';
import type { TPlayersById } from '../../modules/types';
import {
	TradeInCell,
	TradeOutCell,
	TransactionPlayers,
	TransactionPlayersWrapper,
} from '../';
import { TransactionButtonsWrapper } from './TransactionButtonsWrapper';

type Props = {
	players_by_id: TPlayersById,
	trade: Object,
}
export const TradeCompleted = ({ trade, players_by_id, blockTrade, approveTrade }: Props) => {
	const {
		new_player_id, old_player_id, new_team_name, old_team_name
	} = trade;
	return (
		<TransactionPlayersWrapper>
			<TransactionPlayers>
				<p>
					{new_team_name} has offered:
				</p>
				{new_player_id.map(id => (<TradeInCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
			<TransactionButtonsWrapper>

			</TransactionButtonsWrapper>
			<TransactionPlayers>
				<p>
					To {old_team_name}, for:
				</p>
				{old_player_id.map(id => (<TradeOutCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
		</TransactionPlayersWrapper>
	);
};

export default TradeCompleted;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeCompleted.js